import { Alert, Box, Typography } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getOffersForCity, Offer } from '../data/offers'

interface OfferMessageProps {
  cityName?: string
  countryId?: number
  showTitle?: boolean
}

const OfferMessage = ({
  cityName,
  countryId,
  showTitle = true,
}: OfferMessageProps) => {
  const { t } = useTranslation()
  const offers = useMemo(() => {
    if (!cityName) return []
    return getOffersForCity(cityName, countryId)
  }, [cityName, countryId])

  if (offers.length === 0) {
    return null
  }

  return (
    <Box sx={{ mb: 2 }}>
      {showTitle && (
        <Typography
          color="primary"
          sx={{ fontWeight: 'bold', mb: 1 }}
          variant="h6"
        >
          {t('auth.register.special_offers')} {cityName}
        </Typography>
      )}
      {offers.map((offer: Offer) => (
        <Alert
          key={offer.id}
          severity="info"
          sx={{
            '& .MuiAlert-message': {
              width: '100%',
            },
            mb: 1,
          }}
        >
          <Typography sx={{ fontWeight: 'medium' }} variant="body2">
            {offer.message}
          </Typography>
        </Alert>
      ))}
    </Box>
  )
}

export default OfferMessage
